'use client';

import { PLP_SCROLL_POSITION } from '@next-app/constants/session-storage-keys';
import { isBrowser } from '@next-app/utils/common-utils';
import {
  getFromSessionStorage,
  removeFromSessionStorage,
} from '@next-app/utils/session-storage-utils';
import { getCurrentPathName } from '@next-app/utils/window-utils';
import { useEffect } from 'react';

const ResetPLPScroll = () => {
  useEffect(() => {
    // Set a timeout to change the message after 3 seconds
    const timeout = setTimeout(() => {
      if (isBrowser()) {
        try {
          const scrollObject = JSON.parse(
            getFromSessionStorage(PLP_SCROLL_POSITION) || {},
          );
          const pathName = getCurrentPathName();
          if (scrollObject[pathName]) {
            window.scrollTo(0, scrollObject[pathName]);
          }
          removeFromSessionStorage(PLP_SCROLL_POSITION);
        } catch (e) {
          console.log('Error in reading scroll position from session storage');
        }
      }
    }, 600);

    // Cleanup function to clear the timeout if the component unmounts
    return () => {
      clearTimeout(timeout);
    };
  }, []);
  return <></>;
};

export default ResetPLPScroll;
